import axios from 'axios';
import { getOperationTypeNameById, getPropertyNameById, getSubPropertyNameById } from './mapping';

export function sendEvent(
  eventAction = '',
  eventLabel = '',
  operationTypeId = '',
  propertyType = {},
  subPropertyType = {},
  plan,
  price
) {
  const operationType = operationTypeId ? getOperationTypeNameById(operationTypeId) : '';
  const propertyTypeName =
    Object.keys(propertyType).length > 0 ? getPropertyNameById(propertyType.list, propertyType.id) : '';
  const subPropertyTypeName =
    Object.keys(subPropertyType).length > 0 ? getSubPropertyNameById(subPropertyType.list, subPropertyType.id) : '';

  const data = {
    event: 'trackEvent',
    eventCategory: 'Publicador',
    eventAction,
    eventLabel,
    operation_type: operationType,
    tipoDePropiedad: propertyTypeName,
    subTipoDePropiedad: subPropertyTypeName,
    plan,
    price
  };
  window.dataLayer.push(data);
}

export const trackMixpanel = async (event, operationTypeId, realEstateTypeId, id) => {
  const body = {
    event,
    operation_type_id: operationTypeId,
    real_estate_type_id: realEstateTypeId,
    distinct_id: id
  };
  try {
    await axios.post('/ecommerce/api/v1/appraisalnotifications', body);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Unable to send data:', err);
  }
};

export const FORM_ABANDON_EVENT = 'FORM_ABANDON_EVENT';
export const NO_RETRY_EVENT = 'NO_RETRY_EVENT';
export const FAILED_TRANSACTION_EVENT = 'FAILED_TRANSACTION_EVENT';
export const PUBLICATION_ABANDON = 'PUBLICATION_ABANDON';

function getBody(event, id, postingId) {
  if (event === PUBLICATION_ABANDON) {
    return { event, operationTypeId: id, postingId };
  }
  return { event, productId: id };
}

export async function track(event, id = '', postingId = '') {
  if (process.env.REACT_APP_FSBO_TRIPOLIS_ENABLED) {
    const data = getBody(event, id, postingId);
    const url = `${process.env.REACT_APP_API_ECOMMERCE}/ecommerce/api/v1/notifications`;

    if (navigator.sendBeacon) {
      const headers = { type: 'application/json' };
      const blob = new Blob([JSON.stringify(data)], headers);
      await Promise.resolve(navigator.sendBeacon(url, blob));
    } else {
      const headers = {
        'Content-Type': 'application/json',
        'X-NAVENT-APP': 'publicador',
        'x-panel-portal': process.env.REACT_APP_BUILD_SITE
      };
      await axios.post(url, data, { headers });
    }
  }
}
